import { render, staticRenderFns } from "./ModalTextArea.vue?vue&type=template&id=5bdbbf95&scoped=true&"
import script from "./ModalTextArea.vue?vue&type=script&lang=js&"
export * from "./ModalTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ModalTextArea.vue?vue&type=style&index=0&id=5bdbbf95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbbf95",
  null
  
)

export default component.exports